import styled from 'styled-components';
import { CustomDialog } from '../../../../../../../components/dialog/v1/CustomDialog';
import { useState } from 'react';
import CustomBlockButton from '../../../../../../../components/button/CustomBlockButton';
import { returnExchangeDownloadFormVariables } from '../../../../../variables/return-exchange-download-form-variables';
import { customToast } from '../../../../../../../components/toast/custom-react-toastify/v1';

const StyledHeader = styled.div`
    padding: 10px;
`;

const StyledBody = styled.div`
    padding:10px;

    .fieldNames-box{
        .label{
            font-size: 12px;
            font-weight: 600;
            margin-bottom: 5px;
        }

        .grid-box{
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 5px;
            height: 300px;
            overflow-y: auto;
            border: 1px solid #e0e0e0;
            border-radius: 3px;
            padding: 5px;
            
            button{
                font-size: 10px;
                height: 30px;
                border-radius: 3px;
                &.selected{
                    border: 1px solid #333;
                }

                .indexOf{
                    position: absolute;
                    top: 3px;
                    right: 3px;
                    color: #333;
                    border: 1px solid #333;
                    border-radius: 50px;
                    width: 10px;
                    height: 10px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
            }
        }
    }
    
    .valueSeparator-box{
        margin-top: 20px;
        .label{
            font-size: 12px;
            font-weight: 600;
            margin-bottom: 5px;
        }

        .grid-box{
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 5px;

            button{
                font-size: 10px;
                height: 30px;
                border-radius: 3px;
                &.selected{
                    border: 1px solid #333;
                }
            }
        }
    }
`;

const StyledFooter = styled.div`
    padding: 10px;

    button{
        border-radius: 3px;
        border: none;
        background: #333;
        color: #fff;
        font-weight: 600;
    }
`;

export function ModalFieldNames({
    open,
    onClose,
    targetItem,
    onConfirm
}) {
    const [fieldNames, setFieldNames] = useState(targetItem?.fieldNames ? targetItem?.fieldNames : []);
    const [valueSeparator, setValueSparator] = useState(targetItem?.valueSeparator ? targetItem?.valueSeparator : '-');

    const handleAddFieldName = (newFieldName) => {
        if (fieldNames.length >= 5) {
            customToast.error('필드값은 최대 5개까지 선택 가능합니다.');
            return;
        }
        if (fieldNames.includes(newFieldName)) {
            setFieldNames(fieldNames.filter((item) => item !== newFieldName));
        } else {
            setFieldNames([...fieldNames, newFieldName]);
        }
    }

    const handleChangeValueSeparator = (newSeparator) => {
        setValueSparator(newSeparator);
    }

    const handleSubmit = () => {
        onConfirm({
            ...targetItem,
            fieldNames,
            valueSeparator
        });
        onClose();
    }

    return (
        <>
            <CustomDialog
                open={open}
                onClose={onClose}
            >
                <StyledHeader>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>
                            필드값 선택
                        </CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={onClose} />
                    </CustomDialog.Header>
                </StyledHeader>
                <StyledBody>
                    <div className='fieldNames-box'>
                        <div className='label'>필드값 선택 ({fieldNames?.length}개 선택됨)</div>
                        <div className='grid-box'>
                            {returnExchangeDownloadFormVariables?.map((variable, index) => {
                                const isSelected = fieldNames.includes(variable?.fieldName);
                                let indexOf = -1;
                                if (isSelected) {
                                    indexOf = fieldNames.indexOf(variable?.fieldName);
                                }
                                return (
                                    <CustomBlockButton
                                        key={index}
                                        type='button'
                                        onClick={() => handleAddFieldName(variable?.fieldName)}
                                        className={`${isSelected ? 'selected' : ''}`}
                                    >
                                        {variable?.label}
                                        {indexOf !== -1 && <div className='indexOf'>{indexOf + 1}</div>}
                                    </CustomBlockButton>
                                );
                            })}
                        </div>
                    </div>
                    <div className='valueSeparator-box'>
                        <div className='label'>구분자</div>
                        <div className='grid-box'>
                            <CustomBlockButton
                                type='button'
                                className={`${valueSeparator === '\n' ? 'selected' : ''}`}
                                onClick={() => handleChangeValueSeparator('\n')}
                            >
                                줄바꿈(\n)
                            </CustomBlockButton>
                            <CustomBlockButton
                                type='button'
                                className={`${valueSeparator === '\t' ? 'selected' : ''}`}
                                onClick={() => handleChangeValueSeparator('\t')}
                            >
                                들여쓰기(\t)
                            </CustomBlockButton>
                            <CustomBlockButton
                                type='button'
                                className={`${valueSeparator === ' ' ? 'selected' : ''}`}
                                onClick={() => handleChangeValueSeparator(' ')}
                            >
                                띄어쓰기(" ")
                            </CustomBlockButton>
                            <CustomBlockButton
                                type='button'
                                className={`${valueSeparator === ',' ? 'selected' : ''}`}
                                onClick={() => handleChangeValueSeparator(',')}
                            >
                                콤마(,)
                            </CustomBlockButton>
                            <CustomBlockButton
                                type='button'
                                className={`${valueSeparator === '-' ? 'selected' : ''}`}
                                onClick={() => handleChangeValueSeparator('-')}
                            >
                                대시(-)
                            </CustomBlockButton>
                            <CustomBlockButton
                                type='button'
                                className={`${valueSeparator === '_' ? 'selected' : ''}`}
                                onClick={() => handleChangeValueSeparator('_')}
                            >
                                언더바(_)
                            </CustomBlockButton>
                            <CustomBlockButton
                                type='button'
                                className={`${valueSeparator === '&' ? 'selected' : ''}`}
                                onClick={() => handleChangeValueSeparator('&')}
                            >
                                앰퍼샌드(&)
                            </CustomBlockButton>
                            <CustomBlockButton
                                type='button'
                                className={`${valueSeparator === '|' ? 'selected' : ''}`}
                                onClick={() => handleChangeValueSeparator('|')}
                            >
                                파이프(|)
                            </CustomBlockButton>
                        </div>
                    </div>
                </StyledBody>
                <StyledFooter>
                    <CustomBlockButton
                        type='button'
                        onClick={() => handleSubmit()}
                    >
                        적용
                    </CustomBlockButton>
                </StyledFooter>
            </CustomDialog>
        </>
    );
}